import { useCallback, type MouseEventHandler } from 'react';
import { useHistory } from 'react-router-dom';
import { type History } from 'history';

export { useHistory };

export const getHandler =
    (route: string | null = null, history: History<unknown>): MouseEventHandler =>
    e => {
        if (e.ctrlKey || e.shiftKey || e.metaKey || (e.button && e.button === 1)) {
            return;
        }
        if (route) {
            e.preventDefault();
            history.push(route);
        }
    };

export const useRouteClickHandler = (route?: string | null): MouseEventHandler => {
    const history = useHistory();
    return useCallback(getHandler(route, history), [history, route]);
};
